import createIcon from '../../createIcon';

/**
 * @component @name UTurnRight
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNC41IDlWMjFINi41VjlDNi41IDYuNzkgOC4yOSA1IDEwLjUgNUMxMi43MSA1IDE0LjUgNi43OSAxNC41IDlWMTMuMTdMMTIuOTEgMTEuNThMMTEuNSAxM0wxNS41IDE3TDE5LjUgMTNMMTguMDkgMTEuNTlMMTYuNSAxMy4xN1Y5QzE2LjUgNS42OSAxMy44MSAzIDEwLjUgM0M3LjE5IDMgNC41IDUuNjkgNC41IDlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const UTurnRight = createIcon('UTurnRight', [
  [
    'path',
    {
      d: 'M4.5 9V21H6.5V9C6.5 6.79 8.29 5 10.5 5C12.71 5 14.5 6.79 14.5 9V13.17L12.91 11.58L11.5 13L15.5 17L19.5 13L18.09 11.59L16.5 13.17V9C16.5 5.69 13.81 3 10.5 3C7.19 3 4.5 5.69 4.5 9Z',
      key: '1ecbj8',
    },
  ],
]);

export default UTurnRight;
